import request from '../axios'
import requestSec from '../axiosSec'

// 项目追踪
// 获取全部项目
export const projecttrackingprojectList = params => request({
	url: 'tracking/projecttrackingproject/list',
	method: 'get',
	// 输入的是[这个字符，后端tomcat服务器不做url会直接拒绝掉 需对参数做url编码 20260226修改
	params: {
		...params,
		keyword: params.keyword ? encodeURIComponent(params.keyword) : ''
	}
})

// 创建项目
export const projecttrackingprojectAdd = data => request({
	url: 'tracking/projecttrackingproject/add',
	method: 'post',
	data: data,
})

// 移动项目
export const projecttrackingprojectMoveProject = params => request({
	url: 'tracking/projecttrackingproject/moveProject',
	method: 'get',
	params: params
})

// 获取项目详情
export const projecttrackingprojectInfo = params => request({
	url: 'tracking/projecttrackingproject/info/' + params.id,
	method: 'get'
})

// 编辑项目
export const projecttrackingprojectUpdate = data => request({
	url: 'tracking/projecttrackingproject/update',
	method: 'post',
	data: data,
})

// 获取项目成员（全部）
export const projecttrackingmemberList = params => request({
	url: 'tracking/projecttrackingmember/list',
	method: 'get',
	params: params
})

// 获取项目成员（部门等树形结构）
export const projecttrackingprojectGetMemberCanAdd = params => request({
	url: 'tracking/projecttrackingproject/getMemberCanAdd',
	method: 'get',
	params: params
})

// 新增项目成员
export const projecttrackingmemberAddMember = data => request({
	url: 'tracking/projecttrackingmember/addMember',
	method: 'post',
	data: data,
})

// 删除项目成员
export const projecttrackingmemberDelete = data => request({
	url: 'tracking/projecttrackingmember/delete',
	method: 'post',
	data: data,
})

// 删除全部项目成员
export const projecttrackingmemberDeleteAll = params => request({
	url: 'tracking/projecttrackingmember/deleteAll',
	method: 'get',
	params: params
})

// 删除项目
export const projecttrackingprojectDelete = data => request({
	url: 'tracking/projecttrackingproject/delete',
	method: 'post',
	data: data,
})

// 项目详情--获取数据统计
export const projecttrackingprojectStatistics = params => request({
	url: 'tracking/projecttrackingproject/statistics',
	method: 'get',
	params: params
})

// 获取模块列表
export const projecttrackingmoduleList = params => request({
	url: 'tracking/projecttrackingmodule/list',
	method: 'get',
	// 输入的是[这个字符，后端tomcat服务器不做url会直接拒绝掉 需对参数做url编码 20260226修改
	params: {
		...params,
		keyword: params.keyword ? encodeURIComponent(params.keyword) : ''
	}
})

// 跟随记忆--获取展开的模块id
export const projecttrackingmodulehierarchyShowHierarchyService = params => request({
	url: 'tracking/projecttrackingmodulehierarchy/showHierarchyService',
	method: 'get',
	params: params
})

// 跟随记忆--展开/收起模块
export const projecttrackingmodulehierarchySettingHierarchyService = data => request({
	url: 'tracking/projecttrackingmodulehierarchy/settingHierarchyService',
	method: 'post',
	data: data,
})

// 创建模块
export const projecttrackingmoduleAddModule = data => request({
	url: 'tracking/projecttrackingmodule/addModule',
	method: 'post',
	data: data,
})

// 获取模块详情
export const projecttrackingmoduleInfo = params => request({
	url: 'tracking/projecttrackingmodule/info/' + params.id,
	method: 'get'
})

// 获取模块子集需求
export const projecttrackingmoduleRequirementList = params => request({
	url: 'tracking/projecttrackingmodule/requirementList',
	method: 'get',
	// 输入的是[这个字符，后端tomcat服务器不做url会直接拒绝掉 需对参数做url编码 20260312修改
	params: {
		...params,
		keyword: params.keyword ? encodeURIComponent(params.keyword) : ''
	}
})

// 编辑模块(附件务必全量附件ID)
export const projecttrackingmoduleUpdateModule = data => request({
	url: 'tracking/projecttrackingmodule/updateModule',
	method: 'post',
	data: data,
})

// 编辑模块(附件务必全量附件ID)(直接修改状态 协助人 负责人/处理人 附件时调用)
export const projecttrackingmoduleUpdateModuleSimplify = data => request({
	url: 'tracking/projecttrackingmodule/updateModule/simplify',
	method: 'post',
	data: data,
})

// 删除模块
export const projecttrackingmoduleDelete = data => request({
	url: 'tracking/projecttrackingmodule/delete',
	method: 'post',
	data: data,
})

// 发表/回复评论
export const projecttrackingcommentIissue = data => request({
	url: 'tracking/projecttrackingcomment/issue',
	method: 'post',
	data: data,
})

// 获取评论列表
export const projecttrackingcommentList = params => request({
	url: 'tracking/projecttrackingcomment/list',
	method: 'get',
	params: params
})

// 评论获取成员信息
export const sysuserGetUserByName = params => request({
	url: 'sys/sysuser/getUserByName',
	method: 'get',
	params: params
})

// 删除评论
export const projecttrackingcommentDelete = data => request({
	url: 'tracking/projecttrackingcomment/delete',
	method: 'post',
	data: data,
})

// 创建需求
export const projecttrackingrequirementAddRequirement = data => request({
	url: 'tracking/projecttrackingrequirement/addRequirement',
	method: 'post',
	data: data,
})

// 获取需求详情
export const projecttrackingrequirementInfo = params => request({
	url: 'tracking/projecttrackingrequirement/info/' + params.id,
	method: 'get'
})

// 编辑需求
export const projecttrackingrequirementUpdateRequirement = data => request({
	url: 'tracking/projecttrackingrequirement/updateRequirement',
	method: 'post',
	data: data,
})

// 编辑需求(直接修改状态 协助人 负责人/处理人 附件时调用)
export const projecttrackingrequirementUpdateRequirementSimplify = data => request({
	url: 'tracking/projecttrackingrequirement/updateRequirement/simplify',
	method: 'post',
	data: data,
})

// 删除需求
export const projecttrackingrequirementDelete = data => request({
	url: 'tracking/projecttrackingrequirement/delete',
	method: 'post',
	data: data,
})

// 批量删除需求
export const projecttrackingrequirementDeleteBatch = data => request({
	url: 'tracking/projecttrackingrequirement/deleteBatch',
	method: 'post',
	data: data,
})

// @获取成员列表
export const projecttrackingmemberGetProjectUsers = params => request({
	url: 'tracking/projecttrackingmember/getProjectUsers',
	method: 'get',
	params: params
})

// 获取我的待办/创建列表 来源，toDo表示待办，my表示我创建，不可为空
export const projecttrackingrequirementList = params => request({
	url: 'tracking/projecttrackingrequirement/list',
	method: 'get',
	// 输入的是[这个字符，后端tomcat服务器不做url会直接拒绝掉 需对参数做url编码 20260226修改
	params: {
		...params,
		keyword: params.keyword ? encodeURIComponent(params.keyword) : ''
	}
})

// 获取待协助项
export const projecttrackingassistuserList = params => request({
	url: 'tracking/projecttrackingassistuser/list',
	method: 'get',
	// 输入的是[这个字符，后端tomcat服务器不做url会直接拒绝掉 需对参数做url编码 20260226修改
	params: {
		...params,
		keyword: params.keyword ? encodeURIComponent(params.keyword) : ''
	}
})

// 获取项目配置
export const configprojecttrackingInfo = params => request({
	url: 'config/configprojecttracking/info',
	method: 'get',
	params: params
})

// 设置项目配置
export const configprojecttrackingSetDefaultDeploy = data => request({
	url: 'config/configprojecttracking/setDefaultDeploy',
	method: 'post',
	data: data,
})

// 设置项目许可
export const configprojecttrackingSetExportStatus = data => request({
	url: 'config/configprojecttracking/setExportStatus',
	method: 'post',
	data: data,
})

// 系统用量
// export const projecttrackingstageAll = params => request({
// 	url: 'tracking/projecttrackingstage/all',
// 	method: 'get',
// 	params: params
// })

// 获取项目阶段
export const projecttrackingstageAll = params => request({
	url: 'tracking/projecttrackingstage/all',
	method: 'get',
	params: params
})

// 新增项目阶段
export const projecttrackingstageSave = data => request({
	url: 'tracking/projecttrackingstage/save',
	method: 'post',
	data: data,
})

// 编辑项目阶段
export const projecttrackingstageUpdate = data => request({
	url: 'tracking/projecttrackingstage/update',
	method: 'post',
	data: data,
})

// 删除项目阶段
export const projecttrackingstageDelete = data => request({
	url: 'tracking/projecttrackingstage/delete',
	method: 'post',
	data: data,
})

// 获取系统用量
export const configprojecttrackingGetSystemConsumption = params => request({
	url: 'config/configprojecttracking/getSystemConsumption',
	method: 'get',
	// 输入的是[这个字符，后端tomcat服务器不做url会直接拒绝掉 需对参数做url编码 20260226修改
	params: {
		...params,
		keyword: params.keyword ? encodeURIComponent(params.keyword) : ''
	}
})

// 获取相关权限的校验
export const projecttrackingprojectPowerAbout = data => request({
	url: 'tracking/projecttrackingproject/powerAbout',
	method: 'post',
	data: data,
})

// 根据父评论获取子评论
export const projecttrackingcommentListChildren = params => request({
	url: 'tracking/projecttrackingcomment/listChildren',
	method: 'get',
	params: params
})

// 获取最近指定成员列表
export const projecttrackinglastappointList = params => request({
	url: 'tracking/projecttrackinglastappoint/list',
	method: 'get',
	params: params
})

// 保存最近指定成员数据
export const projecttrackinglastappointSaveAppoint = data => request({
	url: 'tracking/projecttrackinglastappoint/saveAppoint',
	method: 'post',
	data: data,
})

// 获取我的待办/我的创建/待协助项涉及项目
export const projecttrackingprojectListProjectAboutMe = params => request({
	url: 'tracking/projecttrackingproject/listProjectAboutMe',
	method: 'get',
	params: params
})

// 根据项目ID获取项目所在页码
export const projecttrackingprojectGetMemberWhere = params => request({
	url: 'tracking/projecttrackingproject/getMemberWhere',
	method: 'get',
	params: params
})

// 需求日志接口
export const projecttrackingrequirementRecordLog = data => request({
	url: 'tracking/projecttrackingrequirement/recordLog',
	method: 'post',
	data: data,
})

// 设置项目字体大小
export const configprojecttrackingSetFontSize = data => request({
	url: 'config/configprojecttracking/setFontSize',
	method: 'post',
	data: data,
})